import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaArrowRight } from 'react-icons/fa';
import { useAuth } from '../../../../auth/AuthContext';
import { getDisplayNameForUI } from '../../../../utils/displayName';

const Profile = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900">Profile</h2>
        <p className="text-gray-600 mt-1">Manage your account and preferences.</p>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <FaUser className="text-2xl text-red-600" />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900">
                {getDisplayNameForUI(user) || 'Customer'}
              </p>
              <p className="text-sm text-gray-600">{user?.email || '—'}</p>
              {user?.mobile && (
                <p className="text-sm text-gray-600">{user.mobile}</p>
              )}
            </div>
          </div>
          <button
            onClick={() => navigate('/account')}
            className="w-full flex items-center justify-between px-4 py-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-900">Edit full profile</span>
            <FaArrowRight className="text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
